/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Article from 'flarum/orell-articles/models/Article';

/** Computed, so neither `Extend.Model` attribute nor relationship applies. */
export default function (): void {
	Article.prototype.status = function (this: Article) {
		const userStatus = this.userStatus();

		return userStatus ? userStatus.status() : false;
	};
}
